export default {
  label: {
    title: {
      create: 'Criar dashboard',
      edit: 'Editar dashboard',
      copyDashboard: 'Copiar componentes de outro dashboard',
      environment: 'Ambiente',
      contractModel: 'Modelo de contrato',
      createdDate: 'Data de criação',
      lastUpdate: 'Última atualização',
      otherEditors: 'Demais editores'
    },
    input: {
      accountId: 'ID da conta',
      universeId: 'ID de pesquisa',
      usersAccess: 'Primeiro editor',
      origim: 'ID do dashboard de origem',
      production: 'Produção',
      staging: 'Staging',
      contract: 'Contratado',
      trial: 'Teste',
      expirationDate: 'Data de expiração *',
    },
    important: 'Importante:',
    firstNote: 'Máximo de 16 caracteres nos campos de ID.',
    secondNote: 'Os IDs só podem conter números.',
    thirdNote: 'Não são permitidos espaços em branco.',
    description: 'Para copiar os componentes é necessário inserir o ID do dashboard de origem no campo abaixo. Os itens copiados são: título, conteúdo e ferramentas de edição. Apenas filtros com valores imutáveis entre todos os painéis são copiados.',
    button: {
      create: 'Criar',
      save: 'Salvar',
      cancel: 'Cancelar',
    },
    table: {
      user: 'Usuário',
      mail: 'E-mail',
      createdDate: 'Data de criação',
      updatedDate: 'Data de atualização',
      onboarding: 'Onboarding'
    },
    message: {
      hint: {
        email: 'Escreva um email e aperte "enter".',
      },
      error: {
        emptyField: 'Não pode ser vazio.',
        withoutSpace: 'Não são permitidos espaços',
        mustBeNumber: 'Não são permitidos letras.',
        invalidInfo: 'Máximo de 16 caracteres.',
        addEmail: 'Adicione algum email.',
        addAllEmails: 'Todos emails precisam ser validos.',
        invalidId: 'ID inválido.',
      }
    }
  }
};
